export default "<app-reports-list ></app-reports-list>"